import styled from 'styled-components'

import Grid from '@totallymoney/ui/components/Grid'
import theme from '@totallymoney/ui/theme'

export const StyledGrid = styled(Grid)`
    padding: 0;

    ${theme.mediaMediumPlus`
        padding: 0 ${theme.space80};
    `}

    ${theme.mediaLargePlus`
        padding: 0 ${theme.space80};
    `}
`
